// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { externalLink } from './assets/modules/externalLink';
import { countdown } from './assets/modules/countdown';
import { trigger } from './assets/modules/trigger';
import { stickySidebar } from './assets/modules/stickySidebar';
import { exhibitors } from './assets/modules/exhibitors';
import { events } from './assets/modules/events';
import { friendsList } from './assets/modules/friendsList';
import { friendsMap } from './assets/modules/friendsMap';
import { yummy } from './assets/modules/yummy';
import { swiperCarousel } from './assets/modules/swiperCarousel';
import { fluidvideo } from './assets/modules/fluidvideo';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { drawer } from './assets/modules/drawer';
import { svgAnimOverlay } from './assets/modules/svgAnimOverlay';

const init = () => {
  hover();
  trigger();
  stickySidebar();
  externalLink();
  countdown();
  exhibitors();
  events();
  friendsList();
  friendsMap();
  yummy();
  swiperCarousel();
  fluidvideo();
  initPhotoSwipeFromDOM('.js-pswp-container');
  drawer();
  svgAnimOverlay();
  document.body.classList.add('is-init')
}

init();